import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledContactUsSuccessState = styled(Flex)`
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

export const StyledContactUsSuccessImageWrapper = styled.div`
    width: 75px;
    height: 70px;

    ${SWReactIcons} {
        position: relative;
        margin: -21px -25px;
    }
`;
